import React, { useEffect, useState } from "react";
import Navbar from "../global/Navbar";
import { CiSearch } from "react-icons/ci";
import VideoCard from "../components/Home/VideoCard";
import { motion } from "framer-motion";
import { course } from "../demodata/Course.jsx";
import { fetchCourses } from "../api/Evaluation";
import Loading from "../utils/Loading.jsx";




const Course = () => {
  const [Courses, setCourses] = useState([]);
   const [loadingCourses, setLoadingCourses] = useState(true);
  const [active, setActive] = useState("thought");
  

  const loadCourses = async () => {
    try {
      const data = await fetchCourses(); 
      setCourses(data);
    } catch (error) {
      console.error("❌ Error fetching courses:", error);
    } finally {
      setLoadingCourses(false);
    }
  };
  
  
  
    useEffect(() => {
     
      loadCourses();
    }, []);


  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b] ">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-[5rem]">
        <div className="mt-[2rem] flex items-center justify-center gap-4 border-b border-[#22BEFF33]">

          <button className={`font-bold text-base cursor-pointer pb-2 ${active === "thought"? "border-b-2 border-[#22BEFF] text-[#22BEFF]": "text-gray-300"}`}onClick={() => setActive("thought")}>
            স্কিল কোর্সেস
          </button>
          {/* <button className={`font-bold text-base cursor-pointer pb-2 ${active === "mind"? "border-b-2 border-[#22BEFF] text-[#22BEFF]": "text-gray-300"}`}onClick={() => setActive("mind")}>
            MIND TEST
          </button>
          <button className={`font-bold text-base cursor-pointer pb-2 ${active === "knowledge"? "border-b-2 border-[#22BEFF] text-[#22BEFF]": "text-gray-300"}`}onClick={() => setActive("knowledge")}>
            KNOWLEDGE TEST
          </button>
          <button className={`font-bold text-base cursor-pointer pb-2 ${active === "wellness"? "border-b-2 border-[#22BEFF] text-[#22BEFF]" : "text-gray-300"}`} onClick={() => setActive("wellness")}>
            WELLNESS TEST
          </button> */}
		  
        </div>

        <div className="flex gap-1 my-[2rem]">
          <span className="text-3xl font-bold text-white uppercase">
            স্কিল কোর্সেস
          </span>
          <span className="text-3xl text-white">
            ({Courses.length} courses)
          </span>
        </div>
        {loadingCourses ? (
          <Loading />
        ) : (
          <div className="w-full grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 mb-4">
            {Courses.map((item, index) => (
              <motion.div
                key={item.id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.4,
                  delay: index * 0.2,
                }}
              >
                <VideoCard item={item} />
              </motion.div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default Course;
